module.exports = __webpack_public_path__ + "static/media/1.eeaf704f.jpg";